import { Input } from "antd"
import { AuthFormItem } from "components/atoms/form"
import React from "react"

export const FormEmailInputForReset = () => {
  return (
    <AuthFormItem
      name="email"
      rules={[
        {
          type: "email",
          message: "メールアドレスを入力してください",
        },
        {
          required: true,
          message: "メールアドレスを入力してください",
        },
      ]}
    >
      <Input placeholder="test@example.com" />
    </AuthFormItem>
  )
}
